<div class="kk-select sorting">
    <div class="kk-select__wrapper">
        <select class="kk-select__select" [(ngModel)]="sort" (ngModelChange)="onModelUpdate($event)" name="sorting">
            <option *ngFor="let option of sortOptions" [ngValue]="option">{{ option.text }}</option>
        </select>
        <div class="icon kk-select__icon">
            <app-svg-icon iconName="chevron_down"></app-svg-icon>
        </div>
    </div>
</div>
